import {SelectFilterProvider} from '@github-ui/filter-core/providers'
import {CheckCircleIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from '@github-ui/repos-rules-types/shared-filter-types'
import type {RuleStatus} from '@github-ui/repos-rules-types/rules-types'
import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter-core'

const OPTIONS: ReadonlyArray<{value: RuleStatus; displayName: string; priority: number}> = [
  {value: 'all', displayName: 'All statuses', priority: 1},
  {value: 'pass', displayName: 'Pass', priority: 2},
  {value: 'fail', displayName: 'Fail', priority: 3},
  {value: 'bypass', displayName: 'Bypass', priority: 4},
]

export class RuleStatusFilterProvider extends SelectFilterProvider {
  constructor(supportedStatuses?: RuleStatus[]) {
    // 'all' clears the filter rather than selecting a status, so it is always offered.
    const options = supportedStatuses
      ? OPTIONS.filter(o => o.value === 'all' || supportedStatuses.includes(o.value))
      : OPTIONS

    super(
      {
        displayName: 'Rule status',
        key: 'rule-status',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: CheckCircleIcon,
        description: `Rule status: ${options.map(o => o.value).join(' | ')}`,
      },
      [...options],
      {
        filterTypes: singleValueFilterTypes,
      },
    )
  }
}
